const MANUAL_LABEL = "Płatność manualna";

const METHOD_LABELS: Record<string, string> = {
  card: "Karta",
  blik: "BLIK",
  tpay_blik_recurring: "BLIK cykliczny",
  tpay: "Przelew (Tpay)",
  tpay_paypo: "PayPo",
  tpay_paypal: "PayPal",
  tpay_raty: "Raty Tpay",
  p24: "Przelewy24",
  klarna: "Klarna",
  googlePay: "Google Pay",
  applePay: "Apple Pay",
  manualPayment: MANUAL_LABEL,
};

const GATEWAY_LABELS: Record<string, string> = {
  STRIPE: "Stripe",
  TPAY: "Tpay",
  MANUAL: "Manual",
};

/** Stable grouping key for a gateway + method pair; every MANUAL order shares one bucket. */
export const getPaymentMethodKey = (gateway: string | null | undefined, method: string | null | undefined) =>
  gateway === "MANUAL" ? "MANUAL" : `${gateway ?? "unknown"}:${method ?? "unknown"}`;

/**
 * Human label of how an order was paid. Anything that went through the MANUAL gateway is a manual
 * payment (transfer, seller-confirmed installment plan) whatever `paymentMethodType` says: the
 * Stripe service stamps "card" as a fallback when it wires a manual installment plan into a
 * subscription, and that stamp is not a card charge. An order that failed before a method was
 * chosen carries only the gateway.
 */
export const getPaymentMethodLabel = (gateway: string | null | undefined, method: string | null | undefined) => {
  if (gateway === "MANUAL") {
    return MANUAL_LABEL;
  }

  const gatewayLabel = gateway ? (GATEWAY_LABELS[gateway] ?? gateway) : null;

  if (!method) {
    return gatewayLabel ? `${gatewayLabel} (bez metody)` : "Nieznana";
  }

  return METHOD_LABELS[method] ?? method;
};
